import Create from './Create';
import Update from './Update';
import Delete from './Delete';
import Body   from './Body'  ;

type Props = {
  Create: typeof Create;
  Update: typeof Update;
  Delete: typeof Delete;
  Body  : typeof Body  ;
}

const AcademicYearComponents: Props = {
  Create,
  Update,
  Delete,
  Body  ,
}

export default AcademicYearComponents;
